import { Link } from "wouter";
import { MarketingScrollLockup } from "@/components/MarketingScrollSymbol";

const footerLinks = [
  { label: "Service update", href: "/" },
  { label: "Support", href: "/support" },
  { label: "Delete account", href: "/delete-account" },
];

const footerLinkClass = "text-sm landing-text-secondary transition-colors hover:landing-text-primary";

export default function MarketingFooter() {
  return (
    <footer className="border-t border-(--landing-border)">
      <div className="mx-auto max-w-7xl px-6 py-12 md:py-14">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:gap-16">
          <div className="max-w-sm">
            <Link href="/" aria-label="Scroll home" className="landing-text-primary inline-flex">
              <MarketingScrollLockup preset="nav" />
            </Link>
            <p className="landing-text-secondary mt-4 text-sm leading-relaxed">
              Scroll is winding down. Existing accounts, exports, and hosted podcast feeds remain available during the transition.
            </p>
          </div>

          <div className="w-full max-w-xs">
            <h2 className="scroll-heading mb-2 text-lg">Need help with your account?</h2>
            <p className="landing-text-secondary mb-4 text-sm leading-relaxed">
              We can help with data exports, podcast migration, subscriptions, and deletion.
            </p>
            <a href="mailto:support@scrollapp.co?subject=Scroll%20transition%20help" className="landing-text-primary text-sm font-semibold underline underline-offset-4">Email support@scrollapp.co</a>
          </div>
        </div>

        <nav aria-label="Footer" className="mt-10 grid grid-cols-2 gap-x-5 gap-y-3 border-t border-(--landing-border) pt-7 sm:flex sm:flex-wrap sm:gap-x-6 md:mt-12">
          {footerLinks.map(({ label, href }) => (
            <Link key={href} href={href} className={footerLinkClass}>{label}</Link>
          ))}
        </nav>

        <div className="landing-text-tertiary mt-8 flex flex-col gap-4 border-t border-(--landing-border) pt-6 text-xs sm:flex-row sm:items-center sm:justify-between">
          <p>
            &copy; 2026 Scroll · Built by{" "}
            <a href="https://bnfy.me" target="_blank" rel="noopener noreferrer" className="font-semibold transition-colors hover:landing-text-primary">
              Bananify
            </a>
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link href="/privacy" className="transition-colors hover:landing-text-primary">Privacy</Link>
            <Link href="/terms" className="transition-colors hover:landing-text-primary">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
